module.exports = __webpack_public_path__ + "img/pro_one_2.a28e0319.jpg";